import { memo } from 'react';

import { SquareLibraryIcon } from '@air/design-icons';

import { MainSideNavItem } from '~/components/v2/components/workspace/main-side-nav/item/MainSideNavItem';
import { useMainSideNavItemSelected } from '~/components/v2/components/workspace/main-side-nav/useMainSideNavItemSelected';
import { useSubSideNavBrowseLastPathHref } from '~/components/v2/store/features/workspace/useSubSideNavBrowseLastPathStore';
import { Pathname } from '~/constants/pathname';
import { Routes } from '~/constants/routes';
import { usePrivateAddOnFeatures } from '~/hooks/usePrivateAddOnFeatures';
import { isSearchSubSideNavPathname } from '~/utils/isSearchSubSideNavPathname';

export type MainSideNavItemLibrariesProps = {
  pathname: string;
};

export const MainSideNavItemLibraries = memo(({ pathname }: MainSideNavItemLibrariesProps) => {
  const { libraries } = usePrivateAddOnFeatures();
  const { subSideNavBrowseLastPathHref } = useSubSideNavBrowseLastPathHref(Routes.home);
  const { isSelected } = useMainSideNavItemSelected({
    isRouteSelected:
      isSearchSubSideNavPathname(pathname) ||
      pathname === Pathname.LibraryGeneral ||
      pathname === Pathname.LibraryByLibraryId ||
      pathname === Pathname.BoardByBoardId ||
      pathname === Pathname.BoardClip ||
      pathname === Pathname.BoardCanvas,
  });

  if (!libraries) {
    return null;
  }

  return (
    <MainSideNavItem
      href={subSideNavBrowseLastPathHref}
      icon={SquareLibraryIcon}
      id="libraries"
      isSelected={isSelected}
      label="Libraries"
    />
  );
});

MainSideNavItemLibraries.displayName = 'MainSideNavItemLibraries';
